import React from 'react';
import { connect } from 'react-redux';
import CenterPanelCreate from './centerPanelCreate';
import RightPanelCreate from './rightPanelCreate';
import CenterPanelUpdate from './centerPanelUpdate';
import RightPanelUpdate from './rightPanelUpdate';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import objectAssign from 'object-assign';

@connect(mapStateToProps)
export default class CreateUpdateWaitingAreaSmsNotification extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  openInsertHelp() {
    window.open(APP.EXTERNAL_LINKS.ViewWaitingArea.HelpCreateSmsAlert, '_blank');
  }
  openUpdateHelp() {
    window.open(APP.EXTERNAL_LINKS.ViewWaitingArea.HelpUpdateSmsAlert, '_blank');
  }

  selectText(e) {
    let field = e.target;
    if (field.createTextRange) {
      var selRange = field.createTextRange();
      selRange.collapse(true);
      selRange.moveStart('character', 0);
      selRange.moveEnd('character', field.value.length);
      selRange.select();
      field.focus();
    } else if (field.setSelectionRange) {
      field.focus();
      field.setSelectionRange(0, field.value.length);
    } else if (typeof field.selectionStart != 'undefined') {
      field.selectionStart = 0;
      field.selectionEnd = field.value.length;
      field.focus();
    }
  }

  render() {
    let rightPanel = {};
    let centerPanel = {};
    let showModal = false;

    if (this.props.updateOrInsert == 'insert') {
      rightPanel = <RightPanelCreate />;
      centerPanel = <CenterPanelCreate selectText={this.selectText} myProviderStatus={this.props.myProviderStatus} />;
    } else if (this.props.updateOrInsert == 'update') {
      rightPanel = <RightPanelUpdate />;
      centerPanel = <CenterPanelUpdate selectText={this.selectText} myProviderStatus={this.props.myProviderStatus} />;
    }

    if (this.props.updateOrInsert == 'insert') showModal = this.props.showCreateSmsNotification;
    else if (this.props.updateOrInsert == 'update') showModal = this.props.showUpdateSmsNotification;

    let smsNotificationModal = showModal ? (
      <Modal
        show={showModal}
        hideWhenClickAway={false}
        className={this.props.updateOrInsert + '-waiting-area-sms-notification waiting-area-sms-notification'}
      >
        <PopupHeader
          title={
            this.props.updateOrInsert && this.props.updateOrInsert.startsWith('insert')
              ? APP.LANGUAGE.UpdateCreateSmsNotification.TitleCreateSmsNotification
              : APP.LANGUAGE.UpdateCreateSmsNotification.TitleUpdateSmsNotification
          }
          helpLink={
            this.props.updateOrInsert.startsWith('insert')
              ? APP.EXTERNAL_LINKS.ViewWaitingArea.HelpCreateSmsAlert
              : APP.EXTERNAL_LINKS.ViewWaitingArea.HelpUpdateSmsAlert
          }
          subtitle={this.props.waitingArea.name}
        />
        <div className="content">
          <div className="main-ui-container meeting-room-create-update">
            <div id="righthandfloatingpanel">
              <div className="right ui rail ">
                <div className="ui sticky">{rightPanel}</div>
              </div>
              {centerPanel}
              <div className="bottom-rail-with-left-and-right-content mrtl">{rightPanel}</div>
            </div>
          </div>
        </div>
      </Modal>
    ) : (
      ''
    );

    return <div>{smsNotificationModal}</div>;
  }
}

function mapStateToProps(state) {
  let selectedWaitingArea = state.waitingAreaReducer.cleanWaitingArea;
  if (!!state.waitingAreaReducer.selectedWaitingAreaId)
    selectedWaitingArea = state.waitingAreaReducer.waitingAreas.find(
      (wa) => wa.id === state.waitingAreaReducer.selectedWaitingAreaId
    );

  const waitingArea = objectAssign({}, state.waitingAreaReducer.cleanWaitingArea, selectedWaitingArea);
  return {
    waitingArea: waitingArea,
    showCreateSmsNotification: state.modalReducer.showCreateSmsNotification,
    showUpdateSmsNotification: state.modalReducer.showUpdateSmsNotification,
    waitingAreaSmsNotificationForm: state.waitingAreaReducer.waitingAreaSmsNotificationForm,
    myProviderStatus: waitingArea.myProviderStatus,
  };
}
